import { CATEGORY_CONFIG } from './config';
import { isL1CategorySlug, L1CategoryConfig } from './types';

export { CATEGORY_CONFIG } from './config';
export { messages as categoryMessages } from './messages';
export type {
  CategoryConfig,
  L1CategoryConfig,
  L1CategorySlug,
  L2CategoryConfig,
} from './types';
export { DEFAULT_L2_RESULT_COUNT, L1_CATEGORY_SLUGS } from './types';
export { withIaCode } from './withIaCode';

export const getL1CategoryConfig = (slug: string): L1CategoryConfig | null =>
  isL1CategorySlug(slug) ? CATEGORY_CONFIG[slug] : null;
